module.exports = __webpack_public_path__ + "images/earnRewardPoints_1a16db8.svg";